import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkts } from '../entity/Stkts-angular';

export const StkTs004List = [{ id: "0", name: "上市上櫃" }, { id: "1", name: "興櫃" }]; // 上市上櫃
export const StkTs006List = [{ id: "0", name: "盤中" }, { id: "1", name: "盤後" }, { id: "2", name: "盤後零股" }, { id: "4", name: "盤中零股" }]; // 分類
export const StkTs007List = [{ id: "0", name: "現股" }, { id: "1", name: "融資" }, { id: "2", name: "融券" }, { id: "3", name: "無券" }]; // 種類
export const StkTs008List = [{ id: "0", name: "買進" }, { id: "1", name: "賣出" }]; // 買賣
export const StkTs011List = [{ id: "0", name: "ROD" }, { id: "1", name: "IOC" }, { id: "2", name: "FOK" }]; // 委託條件
export const StkTs012List = [{ id: "1", name: "市價" }, { id: "2", name: "限價" }]; // 特別交易類型
export const StkTs028List = [{ id: "1", name: "已暫存" }, { id: "2", name: "委託失敗" }, { id: "3", name: "已刪除" }, { id: "5", name: "委託成功" }, { id: "8", name: "部分成交" }, { id: "9", name: "全部成交" }]; // 狀態
export const StkTs030List = [{ id: "0", name: "上市" }, { id: "1", name: "上櫃" }, { id: "2", name: "期貨" }, { id: "3", name: "選擇權" }, { id: "4", name: "興櫃" }, { id: "5", name: "盤中零股-上市" }, { id: "6", name: "盤中零股-上櫃" }, { id: "O", name: "海期" }, { id: "Z", name: "指數" }]; // 商品分類
export const StkTs013List = [{ id: "0", name: "ROD" }, { id: "3", name: "IOC" }, { id: "4", name: "FOK" }]; // 交易情況
export const StkTs014List = [{ id: "1", name: "大於等於" }, { id: "2", name: "小於等於" }]; // 觸價方向
export const StkTs015List = [{ id: "0", name: "關閉預風控" }, { id: "1", name: "開啟預風控" }]; // 預風控功能
export const StkTs016List = [{ id: "0", name: "否" }, { id: "1", name: "是" }]; // 是否為長效單
export const StkTs016bList = [{ id: "1", name: "效期內觸發即失效" }, { id: "3", name: "效期內完全成交即失效" }]; // 觸發結束條件
export const StkTs017List = [{ id: "0", name: "一般" }, { id: "MIT", name: "MIT單" }, { id: "MST", name: "MST單" }, { id: "AB", name: "AB單" }]; // 單別

@Injectable({
  providedIn: 'root'
})
export class StktsServicePkg extends JkEntityV2 {
  StkTs004List = StkTs004List;
  StkTs006List = StkTs006List;
  StkTs007List = StkTs007List;
  StkTs008List = StkTs008List;
  StkTs011List = StkTs011List;
  StkTs012List = StkTs012List;
  StkTs028List = StkTs028List;
  StkTs030List = StkTs030List;
  StkTs013List = StkTs013List;
  StkTs014List = StkTs014List;
  StkTs015List = StkTs015List;
  StkTs016List = StkTs016List;
  StkTs016bList = StkTs016bList;
  StkTs017List = StkTs017List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkts();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      TS001: '交易日期', TS002: '帳號', TS003: '序號', TS004: '上市上櫃', TS005: '商品代號', TS006: '分類', TS007: '種類', TS008: '買賣', TS009: '委託價', TS010: '張數/股數', TS011: '委託條件', TS012: '特別交易類型', TS018: '登入代號', TS019: '備註', TS020: '暫存', TS021: '失敗原因', TS022: '價差委託', TS023: '更新api', TS024: '委託書號', TS025: '委託序號', TS026: '成交口數', TS027: '異動時間', TS028: '狀態', TS029: '商品名稱', TS030: '商品分類', TS031: '平均成交價', KEY0: '流程碼', TS013: '交易情況', TS014: '觸價方向', TS015: '預風控功能', TS016: '是否為長效單', TS016A: '長效單結束日期', TS016B: '觸發結束條件', TS017: '單別'
    };

    this.fieldNames = 'TS001,TS002,TS003,TS004,TS005,TS006,TS007,TS008,TS009,TS010,TS011,TS012,TS018,TS019,TS020,TS021,TS022,TS023,TS024,TS025,TS026,TS027,TS028,TS029,TS030,TS031,KEY0,TS013,TS014,TS015,TS016,TS016A,TS016B,TS017';
    this.fieldLengths = { TS001: 8, TS002: 20, TS003: 4, TS004: 4, TS005: 20, TS006: 4, TS007: 4, TS008: 4, TS009: 8, TS010: 8, TS011: 4, TS012: 4, TS018: 10, TS019: 255, TS020: 1, TS021: 255, TS022: 1, TS023: 1, TS024: 10, TS025: 13, TS026: 8, TS027: 8, TS028: 1, TS029: 60, TS030: 1, TS031: 11.3, KEY0: 1, TS013: 1, TS014: 1, TS015: 1, TS016: 1, TS016A: 8, TS016B: 1, TS017: 3 };
    this.columnDefs = [
      { field: "TS031", headerName: "平均成交價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS024", headerName: "委託書號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TS025", headerName: "委託序號", headerTooltip: "", width: 174, cellDataType: "text", },
      { field: "TS026", headerName: "成交口數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS027", headerName: "異動時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "TS028", headerName: "狀態", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TS029", headerName: "商品名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TS030", headerName: "商品分類", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TS023", headerName: "更新api", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "KEY0", headerName: "流程碼", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TS013", headerName: "交易情況", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTs013List }, },
      { field: "TS014", headerName: "觸價方向", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTs014List }, },
      { field: "TS015", headerName: "預風控功能", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTs015List }, },
      { field: "TS016", headerName: "是否為長效單", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTs016List }, },
      { field: "TS016A", headerName: "長效單結束日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "TS016B", headerName: "觸發結束條件", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTs016bList }, },
      { field: "TS017", headerName: "單別", headerTooltip: "", width: 94, cellDataType: "text", },
      { field: "TS001", headerName: "交易日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "TS009", headerName: "委託價", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "TS002", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TS003", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "TS004", headerName: "上市上櫃", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS005", headerName: "商品代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TS006", headerName: "分類", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS007", headerName: "種類", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS008", headerName: "買賣", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS022", headerName: "價差委託", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TS010", headerName: "張數/股數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS011", headerName: "委託條件", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS012", headerName: "特別交易類型", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TS018", headerName: "登入代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TS019", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "TS020", headerName: "暫存", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TS021", headerName: "失敗原因", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKTS';
    this.isSys = false;
    this.sqlSelect = `SELECT STKTS.*  FROM STKTS`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY TS001,TS002,TS003`;
    this.keyFields = ['TS001', 'TS002', 'TS003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['TS001', 'TS002', 'TS003'];
    this.seqField = 'TS003';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkts): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkts): Promise<Stkts> {
    await super.newRecord(newItem);
    return newItem;
  }




}

